import { CfFileItemProps } from "../types";
import FileItem from "..";
import React from "react";

export const convertCfProps = ({
  file: { file },
  label,
  updatedAt,
  publishDate,
}: CfFileItemProps) => {
  const date = new Date(publishDate || updatedAt);
  const caption = date
    .toLocaleDateString("it-IT", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const props = {
    label,
    file,
    caption,
  };
  return props;
};

const CfFileItem = (props: CfFileItemProps) => (
  <FileItem {...convertCfProps(props)} />
);

export default CfFileItem;
